import { render, staticRenderFns } from "./PublishesView.vue?vue&type=template&id=1a35f2d6&scoped=true&"
import script from "./PublishesView.vue?vue&type=script&lang=ts&"
export * from "./PublishesView.vue?vue&type=script&lang=ts&"
import style0 from "./PublishesView.vue?vue&type=style&index=0&id=1a35f2d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a35f2d6",
  null
  
)

export default component.exports